import Client from './contracts/Client';
import ClientAdapter from './contracts/ClientAdapter';
import JustWatchClientAdapter from './JustWatchClientAdapter';
import LocaleOption from "../entities/contracts/LocaleOption";

export default class ApiClient implements Client {
    private adapter: ClientAdapter;
    
    constructor() {
        this.adapter = new JustWatchClientAdapter();
    }

    setLocale(value: string): void {
        this.adapter.setLocale(value);
    }    
    
    searchMoviesAndTvShows(query: string): Promise<import("../entities/contracts/Item").default[]> {
        return this.adapter.searchMoviesAndTvShows(query);
    }

    getAvailableLocales(): Promise<Array<LocaleOption>> {
        return this.adapter.getAvailableLocales();
    }
}